import { cn } from "@/lib/utils";
import type { DeltaDirection } from "@/lib/analytics/types";

interface DeltaBadgeProps {
  /** Raw ratio — 0.15 means +15%, -0.08 means -8%. */
  value: number;
  direction: DeltaDirection;
}

export function DeltaBadge({ value, direction }: DeltaBadgeProps) {
  const pct = Math.abs(value * 100).toFixed(0);
  const isZero = value === 0;

  const arrow = isZero ? "→" : value > 0 ? "↑" : "↓";
  const sign = isZero ? "±" : value > 0 ? "+" : "-";
  const label = `${arrow} ${sign}${pct}%`;

  return (
    <span
      className={cn(
        "text-xs font-medium tabular-nums",
        direction === "good" && "text-emerald-600 dark:text-emerald-400",
        direction === "bad" && "text-red-500 dark:text-red-400",
        direction === "neutral" && "text-muted-foreground",
      )}
    >
      {label}
    </span>
  );
}
